import { partnerLogoByFolder } from "./partnerLogoMappings";

export const partnerCategories = [
  {
    id: "cybersecurity",
    label: "Cybersecurity",
    folder: "cybersecurity",
    logos: partnerLogoByFolder.cybersecurity,
  },
  {
    id: "networking",
    label: "Networking",
    folder: "enterprise-networking",
    logos: partnerLogoByFolder["enterprise-networking"],
  },
  {
    id: "storage-server",
    label: "Storage and Server",
    folder: "infrastructure-solutions",
    logos: partnerLogoByFolder["infrastructure-solutions"],
  },
  {
    id: "data-security",
    label: "Data Security",
    folder: "data-security",
    logos: partnerLogoByFolder["data-security"],
  },
  {
    id: "endpoint-security",
    label: "Endpoint Security",
    folder: "antivirus",
    logos: partnerLogoByFolder.antivirus,
  },
  {
    id: "software-solutions",
    label: "Software Solution",
    folder: "software-solutions",
    logos: partnerLogoByFolder["software-solutions"],
  },
  {
    id: "cloud",
    label: "Cloud",
    folder: "cloud-service",
    logos: partnerLogoByFolder["cloud-service"],
  },
  {
    id: "backup",
    label: "Backup",
    folder: "backup",
    logos: partnerLogoByFolder.backup,
  },
  {
    id: "computing",
    label: "Computing",
    folder: "computing",
    logos: partnerLogoByFolder.computing,
  },
  {
    id: "virtualization",
    label: "Virtualization",
    folder: "virtualization",
    logos: partnerLogoByFolder.virtualization,
  },
  {
    id: "cctv",
    label: "CCTV",
    folder: "cctv",
    logos: partnerLogoByFolder.cctv,
  },
  {
    id: "collaboration-telephony",
    label: "Collaboration & Telephony",
    folder: "audio-video-conferencing-solutions",
    logos: partnerLogoByFolder["audio-video-conferencing-solutions"],
  },
  {
    id: "online-ups",
    label: "Online UPS",
    folder: "online-UPS",
    logos: partnerLogoByFolder["online-UPS"],
  },
  {
    id: "business-analytics",
    label: "Business Analytics",
    folder: "business-analytics",
    logos: partnerLogoByFolder["business-analytics"],
  },
  {
    id: "database",
    label: "Database & Data Platform",
    folder: "database",
    logos: partnerLogoByFolder.database,
  },
];
